import script from "./AuthHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthHeader.vue?vue&type=script&setup=true&lang=js"

import "./AuthHeader.vue?vue&type=style&index=0&id=79c9d055&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c9d055"]])

export default __exports__